module.exports = __webpack_public_path__ + "/images/logo-m-app-store.2191b02.svg";